import { render, staticRenderFns } from "./WooCommerce.vue?vue&type=template&id=3ed91d8c&"
import script from "./WooCommerce.vue?vue&type=script&lang=js&"
export * from "./WooCommerce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports